import { SaveGuestToDraftActionTypes, SaveGuestToDraftState, SAVE_GUEST_TO_DRAFT_FAILURE, SAVE_GUEST_TO_DRAFT_REQUEST, SAVE_GUEST_TO_DRAFT_SUCCESS } from "./types";

const defaultState: SaveGuestToDraftState = {
  isLoading: false,
  errorMessage: ""
};

export default function saveGuestToDraft(state = defaultState, action: SaveGuestToDraftActionTypes): SaveGuestToDraftState {
  switch (action.type) {
    case SAVE_GUEST_TO_DRAFT_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SAVE_GUEST_TO_DRAFT_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case SAVE_GUEST_TO_DRAFT_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};